import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

const useAutoCloseOnNavigation = (
  autoCloseOnNavigation: boolean,
  close: () => void,
) => {
  const location = useLocation();
  const prevLocationRef = useRef({
    pathname: location.pathname,
    search: location.search,
  });

  useEffect(() => {
    if (!autoCloseOnNavigation) return;

    const hasChanged =
      prevLocationRef.current.pathname !== location.pathname ||
      prevLocationRef.current.search !== location.search;

    if (hasChanged) {
      prevLocationRef.current = {
        pathname: location.pathname,
        search: location.search,
      };
      close();
    }
  }, [location.pathname, location.search, close, autoCloseOnNavigation]);
};

export default useAutoCloseOnNavigation;
